import React, { useState } from 'react';

const InteractiveLogo = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [clickCount, setClickCount] = useState(0);
  
  const handleClick = () => {
    setIsClicked(true);
    setClickCount(clickCount + 1);
    
    // Reset the click effect after animation completes
    setTimeout(() => {
      setIsClicked(false);
    }, 500);
  };
  
  // Different messages that appear based on click count
  const getMessage = () => {
    const messages = [
      "Hello there!",
      "Click me again!",
      "You found the secret!",
      "Keep clicking...",
      "Almost there...",
      "You're persistent!",
      "Okay, that's enough",
      "Just kidding, keep going!",
      "You really like clicking, huh?",
      "10th click achievement unlocked!"
    ];
    
    return messages[clickCount % messages.length];
  };

  return (
    <div 
      className={`interactive-logo ${isHovered ? 'hovered' : ''} ${isClicked ? 'clicked' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <h1 className="logo">
        merlinboii{' '}
        <img
          src="https://em-content.zobj.net/source/softbank/182/crescent-moon_1f319.gif"
          alt="moon"
          className={`moon ${isClicked ? 'spin' : ''}`}
          loading="lazy"
          width="32"
          height="32"
        />
      </h1>
      {isHovered && (
        <div className="logo-tooltip pixel-border-1">
          {clickCount > 0 ? getMessage() : "Click me!"}
        </div>
      )}
      {clickCount >= 5 && (
        <div className="sparkle-container">
          <div className="sparkle sparkle-1"></div>
          <div className="sparkle sparkle-2"></div>
          <div className="sparkle sparkle-3"></div>
        </div>
      )}
    </div>
  );
};

export default InteractiveLogo;
